document.addEventListener('DOMContentLoaded', function() {
  const trustpilotSection = document.getElementById('trustpilot-section');

  if (!trustpilotSection) return;

  const options = {
    root: null,
    rootMargin: '100px',
    threshold: 0
  };

  const loadImages = () => {
    const images = trustpilotSection.querySelectorAll('img[data-src]');
    images.forEach(img => {
      img.src = img.getAttribute('data-src');
    });
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        trustpilotSection.style.opacity = '1';
        loadImages(); 
        observer.unobserve(entry.target);
      }
    });
  }, options);

  observer.observe(trustpilotSection);
});
